import React from "react";

/**
 * @component OrderFirstIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <OrderFirstIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const OrderFirstIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="OrderFirstIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M4 4h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1zm2 14h12a1 1 0 010 2H6a1 1 0 010-2zm0-4h12a1 1 0 010 2H6a1 1 0 010-2zm0-4h12a1 1 0 010 2H6a1 1 0 010-2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
OrderFirstIcon.displayName = "OrderFirstIcon";
export default OrderFirstIcon;
